/**
 * window.a11yPrefs — reads and writes accessibility preferences in localStorage.
 */
(function () {
    const PREFIX = 'a11y_';

    window.a11yPrefs = {
        get(key) {
            try {
                const raw = localStorage.getItem(PREFIX + key);

                return raw === null ? null : JSON.parse(raw);
            } catch (e) {
                return null;
            }
        },

        set(key, value) {
            try {
                localStorage.setItem(PREFIX + key, JSON.stringify(value));
            } catch (e) {}
        },

        clear(key) {
            try {
                localStorage.removeItem(PREFIX + key);
            } catch (e) {}
        },
    };
})();
